import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ShopLocatorService } from "./shop-locator.service";

@NgModule({
    imports: [CommonModule],
    providers: [ShopLocatorService],
})
export class ShopLocatorServiceModule {}
